/** @jsx jsx */
import { Box, Card, Flex, Heading, jsx, Text } from "theme-ui";
import React, { PropsWithChildren } from "react";

import { BuilderBlocks } from "@builder.io/react";
import { BuilderBlock } from "@builder.io/react/dist/types/src/components/builder-block.component";
import BuilderImage from "../image/builder-image";
export type ContentFeatureProps = {
  heading: string;
  image: string;
  builderBlock: BuilderBlock;
} & PropsWithChildren;
export const ContentFeature: React.FC<ContentFeatureProps> = ({
  heading,
  image,
  children,
  builderBlock,
}) => {
  //console.log("image", image);

  return (
    <Card variant="feature" sx={{ position: "relative", height: "100%" }}>
      <Flex
        sx={{
          flexDirection: "column",
          alignItems: "center",
          height: "100%",
        }}
      >
        <Flex
          bg="secondary"
          mt="-50px"
          sx={{
            width: "108px",
            height: "108px",
            borderRadius: "50%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <BuilderImage
            alt={heading}
            url={image}
            lazy={true}
            aspectRatio={""}
            width="64"
            height="64"
          />
        </Flex>

        <Flex
          sx={{
            minHeight: "200px",
            flexDirection: "column",
            alignItems: "center",
            height: "100%",
            flexGrow: 1,
            //justifyContent: "space-around",
          }}
        >
          <Box variant="cards.feature.titleBar">
            <Heading pt={3} as="h3">
              {heading}
            </Heading>
          </Box>
          <Flex
            mt={4}
            sx={{
              justifyContent: "space-between",
              alignItems: "center",
              flexDirection: "column",
              flexGrow: 1,
              height: "100%",
            }}
          >
            <BuilderBlocks
              sx={{ display: "inline", width: "100%", height: "100%" }}
              child
              parentElementId={builderBlock?.id}
              dataPath="this.children"
              blocks={children}
            />
          </Flex>
        </Flex>
      </Flex>
    </Card>
  );
};

export default ContentFeature;
